<div #layoutTopbar [style.display]="isVisible ? 'liline-block' : 'none'" class="layout-topbar"
  [ngClass]="{ 'at-log-in': !!isAtLogin }">
  <div class="p-d-flex p-ai-center">
    <a *ngIf="!isAtLogin" class="topbar-icon-button icon-menu" (click)="toggleSideMenu()"></a>
    <img class="only-for-desktop" [src]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo.png'
      " alt="logo" [srcset]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo@2x.png 2x, ./assets/images/header-logo@3x.png 3x'
      " [style.cursor]="isAtLogin ? 'default' : 'pointer'" (click)="isAtLogin ? null : onLogoClick()" />
  </div>
  <div class="mobile-logo-container">
    <img [src]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo.png'
      " alt="logo" [srcset]="
        isAtLogin
          ? './assets/images/header-logo-holding.svg'
          : './assets/images/header-logo@2x.png 2x, ./assets/images/header-logo@3x.png 3x'
      " [style.cursor]="isAtLogin ? 'default' : 'pointer'" (click)="isAtLogin ? null : onLogoClick()" />
  </div>
  <div *ngIf="!isAtLogin" class="p-d-flex p-ai-center">
    <a *ngIf="unReadNotificationCount === 0" class="topbar-icon-button icon-notice" (click)="
          notificationPanel.toggle($event); updateNotification()"></a>
    <a *ngIf="unReadNotificationCount > 0" class="topbar-icon-button icon-notice" pBadge
      [value]="unReadNotificationCount.toString()" (click)="
          notificationPanel.toggle($event); updateNotification()"></a>

    <button pButton type="button" label="{{ this.locale | optionsMapping : languageOptions }}" icon="pi pi-angle-down"
      iconPos="right" (click)="langPanel.toggle($event)" class="only-for-desktop"></button>
    <div class="topbar-horizontal-divider only-for-desktop"></div>
    <button type="button" class="p-button p-component only-for-desktop" (click)="userInfoPanel.toggle($event)">
      <span>{{ userProfile?.userName }}</span>
      <p-avatar image="./assets/images/ic-person.png" shape="circle"></p-avatar>
    </button>
  </div>
</div>

<p-overlayPanel #notificationPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list" style="height: 260px; overflow: scroll">
    <div *ngFor="let notification of notifications" class="list-item notification"
      [ngClass]="!notification.read ? 'page-title p-text-bold' : ''">
      <ng-container *ngIf="notification.systemCode == 'ExWebSubmission' else otherDomain">
        <div class="p-d-flex p-jc-between">
          <a href="javascript:;" (click)="onNotificationLinkClick(notification); notificationPanel.hide()">
            <p-tag [styleClass]="!notification.read ? 'tag p-text-bold' : 'tag'">
              {{
                notification | notificationTitle | translate
              }}
            </p-tag>
          </a>
          <div>
            {{ notification.createDate | date : envConfig.format.date + " HH:mm" }}
          </div>
        </div>
        <span class="description">
          {{ notification | notificationContent }}
        </span>
      </ng-container>
      <ng-template #otherDomain>
        <div class="p-d-flex p-jc-between">
          <a href="javascript:;" (click)="onNotificationLinkClick(notification); notificationPanel.hide()">
            <p-tag [styleClass]="!notification.read ? 'tag p-text-bold' : 'tag'">
              {{
                notification.subject
              }}
            </p-tag>
          </a>
          <div>
            {{ notification.createDate | date : envConfig.format.date + " HH:mm" }}
          </div>
        </div>
        <span class="description">
          {{ notification.message }}
        </span>
      </ng-template>
      
    </div>
  </div>
  <button pButton type="button" label="More" class="w-100 p-button-outlined p-button-rounded"
    (click)="onNotificationMoreBtnClick(); notificationPanel.hide()"></button>
</p-overlayPanel>

<p-overlayPanel #commonPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item">
      collect 01
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 02
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 03
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 04
      <a href="#" class="list-item-link">移除</a>
    </div>
    <div class="list-item">
      collect 05
      <a href="#" class="list-item-link">移除</a>
    </div>
  </div>
  <button pButton type="button" label="Add" class="w-100"></button>
</p-overlayPanel>

<p-overlayPanel #langPanel [appendTo]="layoutTopbar">
  <div class="list topbar-list">
    <div class="list-item" *ngFor="let languageOption of languageOptions">
      <a (click)="onLanguageChange(languageOption.value); langPanel.hide()">
        {{ languageOption.label }}
      </a>
    </div>
  </div>
</p-overlayPanel>

<p-overlayPanel #userInfoPanel [appendTo]="layoutTopbar">
  <div class="topbar-userinfo">
    <ng-container [ngSwitch]="userProfile?.extranetUserRole">
      <ng-template [ngSwitchCase]="0">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.No" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ userProfile?.userNo }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">
            {{ "UserInfo.SalesName" | translate }}
          </div>
          <div class="p-col-8 p-p-0">{{ userProfile?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ deptName }}</div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="1">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Name" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ userProfile?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">
            {{
            (userProfile?.dealerCode || "") +
            " " +
            (userProfile?.dealerName || "")
            }}
          </div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Email" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ userProfile?.email }}</div>
        </div>
      </ng-template>
      <ng-template [ngSwitchCase]="2">
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Name" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ userProfile?.userName }}</div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Dept" | translate }}</div>
          <div class="p-col-8 p-p-0">
            {{
            (userProfile?.agentCode || "") +
            " " +
            (userProfile?.agentName || "")
            }}
          </div>
        </div>
        <div class="topbar-userinfo-field p-col-12">
          <div class="p-col-4 p-p-0">{{ "UserInfo.Email" | translate }}</div>
          <div class="p-col-8 p-p-0">{{ userProfile?.email }}</div>
        </div>
      </ng-template>
    </ng-container>

    <ng-container>
      <p-divider></p-divider>
      <div *ngIf="
          userProfile?.extranetUserRole === 1 ||
          userProfile?.extranetUserRole === 2
        " class="topbar-userinfo-link">
        <a href="javascript:void(0)" (click)="onChangePasswordLinkClick()">
          {{ "Login.ChangePassword" | translate }}
        </a>
      </div>
      <button pButton type="button" label="Log Out" (click)="onLogoutBtnClick()" class="w-100"></button>
    </ng-container>
  </div>
</p-overlayPanel>
